import { Box, styled } from "@mui/material";

export const SkeletonContent = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(6),
    [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(8),
    },
}));
